<template>
    <form class="navbar-left navbar-form nav-search mr-md-3 m-2 mt-md-2" @keyup.enter="goSearch">
        <div class="input-group">
          <input type="text" placeholder="Search ..." v-model="search" class="form-control" required="">
          <div class="input-group-append">
            <span class="input-group-text" @click="goSearch">
              <i class="la la-search search-icon"></i>
            </span>
          </div>
        </div>
      </form>
</template>
<script>
  export default {

    data() {
      return {
        search: null
      };
    },
    methods: {
      goSearch(){
        if(this.search != null){
          window.location.href = "/files/search?q="+ this.search;
        } else {

        }
      },
      
    }
  }
</script>
